import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import appConfig from '../../appConfig';
import PictionJS from 'piction-js';
import SelectableComponent from '../UMOSelectableItemWrapper';
import ConditionalWrapper from '../ConditionalWrapper';
function UMOThumbnail({ umo, isRestricted, isSelectableItem }) {
  let imageTag;
  let url;
  let thumbWidth = umo.data.w[0] === '0' ? 200 : umo.data.w[0];
  let thumbHeight = umo.data.h[0] === '0' ? 200 : umo.data.h[0];
  const isRestrictThumb =
    isRestricted || umo.thumbnail._data.$.restricted === 'T';

  if (isRestrictThumb) url = './images/thumb/restricted.jpg';
  else if (parseInt(umo.thumbnail._data.$.tsize) !== 0) {
    url = umo.thumbnail.url;
  } else {
    thumbWidth = 200;
    thumbHeight = 200;
    switch (umo.type) {
      case 'AUDIO':
        url = './images/thumb/audio.jpg';
        break;
      case 'DOCUMENT':
        url = './images/thumb/document.jpg';
        break;
      case 'RELATIONAL':
        url = './images/thumb/relational.gif';
        break;
      case 'PHOTO':
        url = './images/thumb/image.jpg';
        break;
      case 'VIDEO':
        url = './images/thumb/video.jpg';
        break;
      default:
        url = './images/thumb/img_nothumb.gif';
        break;
    }
  }

  // for extra small thumbnails- use web Quality as thumbnail
  if (
    umo.type === 'PHOTO' &&
    appConfig.useWebQualityForSmallThumb &&
    (thumbWidth < 100 || thumbHeight < 100) &&
    umo.webQuality
  ) {
    url = umo.webQuality.url;
    thumbHeight = umo.webQuality._data.$.h || thumbHeight;
    thumbWidth = umo.webQuality._data.$.w || thumbWidth;
  }
  const thumbRatio = thumbHeight / thumbWidth;
  // if specific metatag was set to appear on img hover-
  // get from metadata list/tombstone metadata list
  const titleMetatag =
    appConfig.umoTitleMetatag &&
    ((umo.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag) &&
      umo.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag).value) ||
      (umo.metadataList.getMetadata(appConfig.umoTitleMetatag) &&
        umo.metadataList.getMetadata(appConfig.umoTitleMetatag).value));
  const title = titleMetatag || umo.name;

  // hack to fix images with height/width ratio of more than 0.25
  // send fake ratio for justified gallery, so it creates proper image size
  // after load- fix in umoGridLayout to return image to original ratio
  if (thumbRatio < 0.25) {
    imageTag = (
      <ConditionalWrapper
        ParentWrapper={SelectableComponent}
        parentProps={{ selectableKey: umo.id }}
        condition={isSelectableItem}
      >
        <img
          className="image"
          alt={appConfig.umoTitleMetatag ? title : ''}
          src={url}
          width={thumbWidth}
          height={thumbWidth * 0.5}
          data-wide-thumb-fix-ratio={thumbRatio}
          id={`selectableItem-${umo.id}`}
        />
      </ConditionalWrapper>
    );
  } else {
    imageTag = (
      <ConditionalWrapper
        ParentWrapper={SelectableComponent}
        parentProps={{ selectableKey: umo.id }}
        condition={isSelectableItem}
      >
        <img
          alt={appConfig.umoTitleMetatag ? title : ''}
          className="image"
          src={url}
          width={thumbWidth}
          height={thumbHeight}
          id={`selectableItem-${umo.id}`}
        />
      </ConditionalWrapper>
    );
  }

  return imageTag;
}

UMOThumbnail.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  isRestricted: PropTypes.bool,
};

export default injectIntl(UMOThumbnail);
